import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonServices } from 'src/app/Common/CommonServices';
import { User, UserClient, API_BASE_URL } from 'src/app/Services/WOWApi.Service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'src/app/Services/common.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-add-lucky-bucks',
  templateUrl: './add-lucky-bucks.component.html',
  styleUrls: ['./add-lucky-bucks.component.css'],
  standalone: false
})
export class AddLuckyBucksComponent implements OnInit {
  luckyBucksForm: UntypedFormGroup;
  users: User[] = [];
  filteredUsers: User[] = [];
  selectedUser: User | null = null;
  isLoading = false;
  searchTerm: string = '';
  userDetails: User;
  addToAllUsers: boolean = false;
  alsoAddToNewUsers: boolean = false;
  showDropdown: boolean = false;
  highlightedIndex: number = -1;


  private baseUrl: string;
  userCtrl = new FormControl<string>('');
  selectedUsers: User[] = [];
  filteredUserForDropdown!: Observable<User[]>;

  constructor(
    private fb: UntypedFormBuilder,
    private userClient: UserClient,
    private commonServices: CommonServices,
    private http: HttpClient,
    private commonService: CommonService,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    this.buildForm();
  }

  ngOnInit(): void {
    this.loadUsers();
  }

  buildForm(): void {
    this.luckyBucksForm = this.fb.group({
      // userId: [''],
      amount: ['', [Validators.required, Validators.min(0.01)]],
      description: [''],
      userIdList: [[]]
    });

    // Update validation when "Add to All Users" changes
    // this.luckyBucksForm.get('userIdList')?.valueChanges.subscribe(() => {
    //   this.updateUserIdValidation();
    // });
  }

  updateUserIdValidation(): void {
    const userIdControl = this.luckyBucksForm.get('userIdList');
    if (this.addToAllUsers) {
      userIdControl?.clearValidators();
    } else {
      userIdControl?.setValidators([Validators.required]);
    }
    userIdControl?.updateValueAndValidity();
  }

  onAddToAllUsersChange(): void {
    if (this.addToAllUsers) {
      this.selectedUser = null;
      this.searchTerm = '';
      this.luckyBucksForm.patchValue({ userIdList: [] });
      this.showDropdown = false;
      this.highlightedIndex = -1;
    }
    this.updateUserIdValidation();
  }

  loadUsers(): void {
    this.isLoading = true;
    this.userClient.getUsers().subscribe(
      (users: User[]) => {
        console.log('Total users received from API:', users.length);
        if (users.length > 0) {
          console.log('Sample user object:', JSON.stringify(users[0], null, 2));
          console.log('Sample user roleId:', users[0].roleId);
          console.log('Sample user isOwner:', users[0].isOwner);
          console.log('Sample user emailId:', users[0].emailId);
        }

        // Temporarily remove restrictive filter to see all users
        // Filter: only exclude if isOwner is explicitly true
        // Note: isOwner might not be set for all users, so we'll be lenient
        this.users = users.filter(u => {
          // Include user if:
          // 1. isOwner is not set (undefined/null) OR isOwner is false
          // 2. OR if roleId is not 1 (assuming 1 is admin role, but this might be wrong)
          const exclude = u.isOwner === true;
          if (exclude) {
            console.log('Excluding user (isOwner=true):', u.emailId);
          }
          return !exclude;
        });

        this.filteredUsers = [...this.users];
        this.filteredUserForDropdown = JSON.parse(JSON.stringify(this.users));
        this.filteredUserForDropdown = this.userCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || ''))
        );
        this.showDropdown = false;
        this.isLoading = false;
        console.log('Filtered customer users:', this.users.length);

        if (this.users.length === 0 && users.length > 0) {
          console.warn('All users were filtered out! Showing all users as fallback.');
          // Fallback: show all users if filter removed everything
          this.users = users;
          this.filteredUsers = [...this.users];
        }

        if (this.users.length === 0) {
          this.commonServices.showMessage('warning', 'No users found. Please check if users exist in the system.', 5);
        }
      },
      (error) => {
        console.error('Error loading users:', error);
        this.commonServices.showMessage('error', 'Failed to load users: ' + error, 5);
        this.isLoading = false;
      }
    );
  }

  onUserSearch(): void {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      this.filteredUsers = [...this.users];
      this.showDropdown = this.filteredUsers.length > 0 && !this.selectedUser;
      this.highlightedIndex = -1;
      return;
    }

    const search = this.searchTerm.toLowerCase().trim();
    this.filteredUsers = this.users.filter(user => {
      const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
      const email = (user.emailId || '').toLowerCase();
      return fullName.includes(search) || email.includes(search);
    });
    this.showDropdown = !this.selectedUser; // Show dropdown even if no results (to show "no results" message)
    this.highlightedIndex = -1;
  }

  onUserSearchFocus(): void {
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      this.onUserSearch();
    } else {
      this.filteredUsers = [...this.users];
      this.showDropdown = this.filteredUsers.length > 0 && !this.selectedUser;
    }
  }

  onUserSearchBlur(): void {
    // Delay hiding dropdown to allow click events to fire
    setTimeout(() => {
      // Only hide if user hasn't clicked on a dropdown item
      if (!this.selectedUser) {
        this.showDropdown = false;
        this.highlightedIndex = -1;
      }
    }, 300);
  }

  // onKeyDown(event: KeyboardEvent): void {
  //   if (!this.showDropdown || this.filteredUsers.length === 0) {
  //     return;
  //   }

  //   switch (event.key) {
  //     case 'ArrowDown':
  //       event.preventDefault();
  //       this.highlightedIndex = (this.highlightedIndex + 1) % this.filteredUsers.length;
  //       break;
  //     case 'ArrowUp':
  //       event.preventDefault();
  //       this.highlightedIndex = this.highlightedIndex <= 0 
  //         ? this.filteredUsers.length - 1 
  //         : this.highlightedIndex - 1;
  //       break;
  //     case 'Enter':
  //       event.preventDefault();
  //       if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredUsers.length) {
  //         this.onUserSelect(this.filteredUsers[this.highlightedIndex]);
  //       }
  //       break;
  //     case 'Escape':
  //       event.preventDefault();
  //       this.showDropdown = false;
  //       this.highlightedIndex = -1;
  //       break;
  //   }
  // }

  // onUserSelect(user: User, event?: Event): void {
  //   if (event) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  //   this.selectedUser = user;
  //   this.luckyBucksForm.patchValue({
  //     userId: user.id
  //   });
  //   this.searchTerm = `${user.firstName} ${user.lastName} (${user.emailId})`;
  //   this.filteredUsers = [];
  //   this.showDropdown = false;
  //   this.highlightedIndex = -1;
  // }

  clearUserSelection(): void {
    this.selectedUser = null;
    this.searchTerm = '';
    this.luckyBucksForm.patchValue({
      userIdList: []
    });
    this.filteredUsers = [...this.users];
    this.showDropdown = false;
    this.highlightedIndex = -1;
  }

  onSubmit(): void {
    console.log('Form submitted with values:', this.luckyBucksForm.value);
    // return;
    if (this.luckyBucksForm.invalid) {
      this.commonServices.showMessage('error', 'Please fill in all required fields correctly.', 5);
      return;
    }

    if (!this.addToAllUsers && (this.luckyBucksForm.get('userIdList')?.value.length === 0)) {
      this.commonServices.showMessage('error', 'Please select users or choose "Add to All Users".', 5);
      return;
    }

    const formValue = this.luckyBucksForm.value;
    formValue.amount = parseFloat(formValue.amount);
    formValue.amount = formValue.amount.toFixed(2);
    const payload = {
      userIdList: this.addToAllUsers ? 0 : formValue.userIdList,
      amount: parseFloat(formValue.amount),
      description: formValue.description || '',
      alsoAddToNewUsers: this.alsoAddToNewUsers // This will be mapped to AlsoAddToNewUsers by the backend
    };
    console.log('Payload to be sent to API:', payload);
    this.isLoading = true;
    // const apiUrl = this.addToAllUsers 
    //   ? `${this.baseUrl}/api/Wallet/AddCreditToAllUsers`
    //   : `${this.baseUrl}/api/Wallet/AddCredit`;

    const apiUrl = this.addToAllUsers
      ? `${this.baseUrl}/api/Wallet/AddCreditToAllUsers`
      : `${this.baseUrl}/api/Wallet/AddCreditToUsersList`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.http.post(apiUrl, payload, { headers }).subscribe(
      (response: any) => {
        if (this.addToAllUsers) {
          const successCount = response.successCount || response.SuccessCount || 0;
          let message = `Successfully added $${formValue.amount} Lucky Bucks to ${successCount} user(s)! All users will receive email notifications.`;
          if (this.alsoAddToNewUsers) {
            message += ` Future new users who sign up will also automatically receive $${formValue.amount} Lucky Bucks.`;
          }
          this.commonServices.showMessage('success', message, 10);
        } else {
          this.commonServices.showMessage('success',
            `Successfully added $${formValue.amount} Lucky Bucks to selected users' wallets!`,
            5);
        }
        this.luckyBucksForm.reset();
        this.clearUserSelection();
        this.addToAllUsers = false;
        this.alsoAddToNewUsers = false;
        this.updateUserIdValidation();
        this.isLoading = false;
        this.selectedUsers = [];
        this.userCtrl.reset('');
      },
      (error) => {
        let errorMessage = 'Failed to add Lucky Bucks.';
        if (error.error && typeof error.error === 'string') {
          errorMessage = error.error;
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.error && error.error.Message) {
          errorMessage = error.error.Message;
        }
        this.commonServices.showMessage('error', errorMessage, 5);
        this.isLoading = false;
      }
    );
  }

  onReset(): void {
    this.luckyBucksForm.reset();
    this.clearUserSelection();
  }


  private _filter(value: string | User): User[] {

    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : `${value.firstName} ${value.lastName}`.toLowerCase();

    return this.filteredUsers.filter(user =>
      (`${user.firstName} ${user.lastName}`)
        .toLowerCase()
        .includes(filterValue) &&
      !this.selectedUsers.some(s => s.id === user.id)
    );
  }

  // ✅ SELECT USER
  selected(event: MatAutocompleteSelectedEvent): void {
    const user = event.option.value as User;

    if (!this.selectedUsers.some(u => u.id === user.id)) {
      this.selectedUsers.push(user);
      this.updateFormControl(); // 🔥 sync with form
    }

    this.userCtrl.reset('');
  }

  // ✅ REMOVE USER
  remove(user: User): void {
    this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
    this.updateFormControl(); // 🔥 sync again
  }

  // 🔥 CORE LOGIC → STORE ONLY IDs
  private updateFormControl(): void {
    const ids = this.selectedUsers.map(u => u.id);

    this.luckyBucksForm.get('userIdList')?.setValue(ids);
    this.luckyBucksForm.get('userIdList')?.markAsDirty();
  }
}

